export default {
  // GLOBAL
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description':
    "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'global#facet_empty_text' : 'Nessun elemento disponibile',
  'global#facet_loading_text': 'Caricamento...',

  // READMORE
  'readmore#label': 'Mostra tutto',
  'readmore#more': 'Leggi tutto',
  'readmore#less': 'Chiudi',

  // SEARCH
  // Page title
  'search#title_bibliographies': 'Bibliografia',
  'search#title_biographies': 'Vite antiche',
  'search#title_iconographies': 'Vite antiche',
  'search#title_tools': 'Materiali e strumenti',
  // Total results
  'search#works_total': '<strong>{ total }</strong> Opere',
  'search#works_total_1': '<strong>{ total }</strong> Opera',
  'search#works_total_0': 'Nessuna Opera',
  'search#books_total': '<strong>{ total }</strong> Opere',
  'search#books_total_1': '<strong>{ total }</strong> Pera',
  'search#books_total_0': 'Nessuna Opera',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#manuscript_total': '<strong>{ total }</strong> Manoscritti',
  'search#manuscript_total_1': '<strong>{ total }</strong> Manoscritto',
  'search#manuscript_total_0': 'Nessun Manoscritto',
  'search#bibliographies_total':
    '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1':
    '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  // Facets
  'search#facets_title': 'Filtra i risultati',
  'search#placeholder_query': 'Cerca nei titoli',
  'search#placeholder_query-content': 'Cerca nelle opere contenute',
  'search#placeholder_filigrana': 'Cerca nella filigrana',
  'search#placeholder_titolo_contenuti': 'Cerca nei titolo dei contenuti',
  'search#placeholder_authors': 'Cerca un autore',
  'search#placeholder_name': 'Cerca tra le persone',
  'search#placeholder_place': 'Cerca nei luoghi',
  'search#placeholder_bibl': 'Cerca nelle fonti',
  'search#placeholder_library': 'Cerca tra le biblioteche',
  'search#header_filigrana' : 'Filigrana',
  'search#header_authors': 'Autori',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#header_years' : 'Data degli autografi',
  'search#date': 'data',
  'search#header_subject' : 'Materia',
  'search#header_sigilli' : 'Sigilli',
  'search#header_autografo' : 'Autografo',
  'search#header_structure' : 'Struttura',
  'search#header_library' : 'Biblioteca',
  'search#header_fund' : 'Fondo',
  'search#header_risorse_digitali' : 'Risorse digitali',
  'search#header_nameCart' : 'Nomi legati al carteggio',
  'search#header_year' : 'Anno',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#header_names': 'Persone',
  'search#header_places': 'Luoghi',
  'search#header_bibl': 'Fonti',
  'search#redirect_link_advanced': 'Vai alla Ricerca Avanzata',
  'search#description_button': 'Info',
  'search#description_link': 'Chiudi',
  // Order
  'search#sort_title': 'Ordine',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  // Results
  'search#filters_title': 'Filtri attivi:',
  'search#resultsamount': 'Risultati per pagina',
  'search#results_number': 'Risultati per pagina',
  'search#fallback_text':
    'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_text':
    'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_button': 'Resetta la ricerca',

  // RESOURCE
  'resource#authors': 'di',
  'resource#author': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#metadata_size': 'Dimensioni',
  'resource#collection_letters': 'Lettere collegate',
  'resource#collection_relations': 'Opere collegate',
  'resource#collection_edition': 'Edizioni di riferimento',

  // TABS
  'tabs#manuscript_contents' : 'CONTENUTI',
  'tabs#manuscript_details' : 'SCHEDA DI DETTAGLIO',
  'tabs#manuscript_bibliography' : 'BIBLIOGRAFIA',
  'tabs#manuscript_cataloging_info' : 'INFO CATALOGAZIONE',
  'tabs#manuscript_where_to_find' : 'DOVE TROVARLO',

  // ADVANCED SEARCH
  'advancedsearch#submit': 'Cerca',
  'advancedsearch#reset': 'Pulisci i campi',
  'advancedsearch#works_total': '<strong>{ total }</strong> risultati',
  'advancedsearch#works_total_1': '<strong>{ total }</strong> risultato',
  'advancedsearch#works_total_0': 'Nessun risultato',
  'advancedsearch#section_opere': 'Opere',
  'advancedsearch#section_manoscritti': 'Manoscritti',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#label_title': 'Titolo',
  'advancedsearch#label_work': 'Opere',
  'advancedsearch#label_manuscript': 'Manoscritti',
  'advancedsearch#label_editor': 'Editor',
  'advancedsearch#label_genere': 'Genere',
  'advancedsearch#label_lingua': 'Lingua',
  'advancedsearch#label_forma': 'Forma',
  'advancedsearch#label_data': 'Data',
  'advancedsearch#label_edition': 'Edizione',
  'advancedsearch#label_query_text': 'Cerca nel testo',
  'advancedsearch#distance_value': 'Parole interposte',
  'advancedsearch#label_cnmd': 'CNMD',
  'advancedsearch#label_struttura': 'Struttura',
  'advancedsearch#label_unita': 'Contenuti',
  'advancedsearch#label_storia_manoscritto': 'Storia del manoscritto',
  'advancedsearch#label_osservazioni_ms': 'Osservazioni',
  'advancedsearch#label_descrizione_generale': 'Descrizione generale',
  'advancedsearch#label_tipologia': 'Tipologia',
  'advancedsearch#label_natura': 'Natura',
  'advancedsearch#label_luoghi': 'Luoghi',
  'advancedsearch#label_persone': 'Persone',

  // ITINERARY
  'itinerary#related_res_title': 'Elementi collegati',
};
